import onError from './onError';
import Api from './Api';

/**
 * Sends count & tags to our internal metrics api.
 *
 * Note that it is preferred to use $stats on the Rails backend if available,
 * since it batches calls to Datadog intelligently.
 *
 * However this is available for use if your feature is front-end only.
 *
 * Metrics are now allowlisted in app/models/metric.rb and need to be added
 * to the VALID_METRICS allow list in order for new metrics to appear in Datadog.
 */

const baseUrl = window.location.origin;

const sendMetric = (metricName, tags = {}) => {
  Api.post(`${baseUrl}/product/metrics/count`, {
    metric_name: metricName,
    tags,
  })
    .then(res => res.ok)
    .catch(onError);
};

export { sendMetric };
